import { localStorageBasicData } from "./";
import { useGlobalStore } from "@/store/Modules/global";
import { ROUTESNAMES } from "@/helpers";
import placeholderImg from "@/assets/images/placeholder(doNotRemove).jpg";
import { useCookie } from '#app';


const isString = (x) => Object.prototype.toString.call(x) === "[object String]";
const isTokenValid = (token) => {
  if(!token || typeof token !== 'string'){
    return false;
  }
  const decodedToken = token
  ? JSON.parse(atob(token.split(".")[1]))
  : {};
    if (decodedToken?.exp) {
      return decodedToken?.exp * 1000 >= new Date().getTime();
    } else {
      return false;
    }
}
const isEmpty = (v) => {
  if(Array.isArray(v)){
    return v.length==0?true:false
  }else if(typeof(v)=='object'){
    return Object.keys(v).length==0?true:false
  }else{
    // console.error("argument in function isEmpty() is not an type of  array or object ")
    return true
  }
}

const constructQueryString = (headersArray) => {
  if (!Array.isArray(headersArray) || headersArray.length === 0) {
    return '';
  }

  const queryString = headersArray?.filter(header => header?.value)
    ?.map((header) => {
      const key = encodeURIComponent(header.key);
      const value = encodeURIComponent(header.value);
      return `${key}=${value}`;
    })
    .join('&');

  return queryString?.length > 0 ? `?${queryString}` : queryString;
}

const buildStoreLink = (storeName, storeLogo = null) => {
  if(!storeName){
    return '#';
  }
  return `${ROUTESNAMES.user.store}/${storeName}`;
}

const buildProductLink = (productItem, portalPage = null) => {
    if(!productItem){
      return '#';
    }
    const localStorageCopy = useGlobalStore()?.localStorageCopy;
    const cookieStorageCopy = useCookie('localStorageCopy')?.value;
    const language = localStorageCopy?.language || cookieStorageCopy?.language;
    const isArabic = language === 'ar';
    const nameKey = `name_${isArabic ? 'ar' : 'en'}`;
    if(portalPage){
      localStorage.setItem('portalPage', portalPage);
    }
    return `${ROUTESNAMES.user.products}/${stripAwaySpecialCharacters(
      productItem?.store?.username,
      "store"
    )}/${productItem?.id}/${stripAwaySpecialCharacters(
      productItem[nameKey],
      "product"
    )}`;
}

const youtubeParser = (url) => {
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = url.match(regExp);
  return (match&&match[7].length==11)? match[7] : false;
}
const roundWithHalf = (number) => {
      const rounded = Math.floor(number);
      const decimalPart = number - rounded;

      if (decimalPart >= 0.5) {
        return rounded + 0.5;
      } else {
        return rounded;
      }
};
// text trimmer
const trimText = (txt, limit) =>
(typeof txt === 'string' || typeof txt === 'number')
  ? `${
      txt.split("").length > limit
        ? txt.split("").slice(0, limit).join("") + "..."
        : txt
    }`
  : "";

const lowerString = (txt) =>
 typeof txt === "string"
    ? txt.toLowerCase()
    : typeof txt === "number"
    ? txt
    : "";

const upperString = (txt) =>
  typeof txt === "string"
    ? txt.toUpperCase()
    : typeof txt === "number"
    ? txt
    : "";
 const capFirstLetter = (txt) =>
      typeof txt === "string"
        ? `${txt.charAt(0)?.toUpperCase()}${txt.slice(1)}`
        : "";
const cacheControl = (values) => ({ res }) => {
    if (!process.server) return;
  
    const cacheControlValue = Object.entries(values)
      .map(([key, value]) => `${key}=${value}`)
      .join(',');
  
    res.setHeader('Cache-Control', cacheControlValue);
  };

const generateRandomId = () => {
  const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let id = '';

  for (let i = 0; i < 10; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    id += characters.charAt(randomIndex);
  }

  return id;
}
const useLocalStorage = ({type, key, value, callBack}) => {
  const localStorageAppKey = "cezma";
  if(!process.client || !window?.localStorage){
    return;
  }
  const global = useGlobalStore();
  switch(lowerString(type)){
    case "set": {
      if(!key){
        return;
      }
      const storageCopy = useLocalStorage({type: 'get'});
      const newLocStorageArr = {...storageCopy, [key] : value};
      Object.keys(localStorageBasicData).forEach(key => {
          if(!Object.prototype.hasOwnProperty.call(newLocStorageArr, key)){
            newLocStorageArr[key] = localStorageBasicData[key];
          }
      });
      localStorage.setItem(localStorageAppKey, JSON.stringify(newLocStorageArr));
      window.dispatchEvent( new Event('storage')); // triggers the localstorage event listener(s)
      // updates data in the store
      global?.updateLocalStorageCopy(newLocStorageArr);
      return;
    }
    case "get": {
      // let loc=JSON.parse(localStorage.getItem(localStorageAppKey))
      // return key?loc[key]:loc
      const localCopy = JSON.parse(localStorage.getItem(localStorageAppKey));
      let getLocalStorageData = "";
      if(key){
        getLocalStorageData = Object.prototype.hasOwnProperty.call(localCopy, key) ? localCopy[key] : null;
      }else{
        getLocalStorageData = localCopy;
      }
      return getLocalStorageData;
    }case 'delete':{
      let loc=JSON.parse(localStorage.getItem(localStorageAppKey))
      if(loc&& key in loc ){
        delete loc[key]
        localStorage.setItem(localStorageAppKey, JSON.stringify({...loc}));
      }
      break;
    }
    case "reset": {
      localStorage.setItem(localStorageAppKey,  JSON.stringify(localStorageBasicData));
      window.dispatchEvent( new Event('storage') );
      // updates data in the store
      global?.updateLocalStorageCopy(localStorageBasicData);
      return;
    }
    case "listener": {
      if(typeof callBack !== 'function'){
        return;
      }
      window?.addEventListener('storage', () => {
        return callBack(useLocalStorage({type: 'get'}));
      });
      break;
    }
    case "clear": {
      localStorage.setItem(localStorageAppKey, JSON.stringify({}));
      window.dispatchEvent( new Event('storage') );
      // updates data in the store
      global?.updateLocalStorageCopy({});
      return;
    }
    default: () => {}
  }
}

const updateParamOptionsInLocalStorage = ({newValue = {}, pageId = ''}) => {
  if(!pageId){
    return;
  }
  const newObjectToSave = {
    [pageId]: newValue
  } 
  // paramOptions
  useLocalStorage({type: 'set', key:'paramOptions', value: newObjectToSave});
};

const  toArabicNumber = (value) => {
  const arabicDigits = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];

  // Ensure the input is a string for easy processing
  if(typeof value !== 'number' || typeof value !== 'string') {
    return "";
  } 
  const strValue = value?.toString();

  const finalVal = strValue
    .split('') // Split the string into individual characters
    .map(char => (char >= '0' && char <= '9') ? arabicDigits[char] : char) // Convert if it's a digit
    .join(''); // Join back into a string
    return finalVal;
}

const arabizeNumbers = (str) => {
  const global = useGlobalStore();
  const currentLang = global?.localStorageCopy?.language;
  if(typeof(str)==='number'){
    str=str.toLocaleString()
  }else if(typeof str !== 'string'){
    return "";
  }
  if(lowerString(currentLang) !== 'ar'){
    return str;
  }
  var id= ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  return str.replace(/[0-9]/g, function(w){
  return id[+w]
  });
}

const useTempValue = ({type, to, value}) => {
  const localStorageId = 'tempId';
  if(type === 'set'){ 
    if(!to || (!value && value != null)) return;
    // set Id
    localStorage.setItem(localStorageId, JSON.stringify({to, value}));
  }else if(type === 'get'){
    // get and destroy it
    const {to = '', value = ''} = JSON.parse(localStorage.getItem(localStorageId)) || {};
     localStorage.removeItem(localStorageId);
    return {to, value};
  }
};

const stripAwaySpecialCharacters = (name, placeholder) => {
  // return encodeURIComponent(name || placeholder);
  return name ? name.toString()?.replace(/[\/|\s|%?]/g, "-") || placeholder : placeholder;
}
const generateWhatsappLink = ({phone_number, message, link}) => {
  if(phone_number && message){
    // todo: use regex
    let formattedPhoneNumber = phone_number.replace(/^(002|\+2)/,'2');
    if(!/^[2]/.test(formattedPhoneNumber)){
      formattedPhoneNumber = `2${formattedPhoneNumber}`
    }
    return `https://api.whatsapp.com/send/?phone=${formattedPhoneNumber}&text=${message}
    ${link ? link : ''}
    `;
  }else{
    return '';
  }
};
const groupAttributesByParent = (array, parentKey = 'parent', filterOutReadOnlyAttrs = false) => {
  const result = [];
  const parentsMap = {};
  array.forEach(item => {
    const parent = item[parentKey];
    if(!parent || (filterOutReadOnlyAttrs ? parent?.display_as_text: false)){
      return;
    }
    if (!parentsMap[parent.id]) {
      parentsMap[parent.id] = {
        parent: parent,
        children: []
      };
    }
    
    parentsMap[parent.id].children.push(item);
  });

  for (const parentId in parentsMap) {
    result.push(parentsMap[parentId]);
  }

  return result;
}

const generateTelegramLink = (username) => username ? `https://telegram.me/${username}` : '';
const generateUniqueID = () => Math.random().toString(36).substr(2, 9);

const customValidators = {
  numeric: (value) => /^[0-9]*$/.test(value),
  youtubeURL: (value) => /(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/.test(value),
  // youtubeURLOptional: (value) => value === "" ? true :/(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/.test(value),
  // facebookURLOptional: (value) => value === "" ? true : /^(?:(?:https?:)?\/\/)?(?:www\.)?facebook\.com\/[a-zA-Z0-9\.]+\/videos\/(?:[a-zA-Z0-9\.]+\/)?([0-9]+)/.test(value)
  facebookURLOptional: (value) => value === "" ? true : /(?:https?:\/\/)?(?:www\.)?(?:facebook\.com\/(?:watch\?v=)?|fb\.watch\/)(\w+)/.test(value)
}

const removeDuplicatedObjectsFromAnArray = ({array, keyToCheck = 'id'}) => {
  return Array.from(
    new Set(array.map((x) => x[keyToCheck]))
  ).map((w) => array.find((el) => el[keyToCheck] === w));
}
const getCurrentLocation = () => {

  return new Promise((resolve, reject) => {
    let isSupported = 'navigator' in window && 'geolocation' in navigator;

    const success = (position) => {
      const coordinates = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };
      resolve(coordinates);
    }

    const error = (error) => {
      console.error("Error getting location:", error);
      reject(error);
    }

    const options = {
      enableHighAccuracy: true,
      maximumAge: 2000,
      timeout: 1000 * 5
    };

    if (isSupported) {
      navigator.geolocation.getCurrentPosition(success, error, options);
    } else {
      reject(new Error('Geolocation is not supported in this browser.'));
    }
  });
};
const parseQueryString = (queryString) =>  {
  const params = {};
  const searchParams = new URLSearchParams(queryString);
  for (const [key, value] of searchParams.entries()) {
    params[key] = value;
  }
  return params;
};
// debounceFunc debounce
const debounceFunc=(func, delay)=> {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, Number(delay));
  };
}

const extractYouTubeId = (url = '') => {
  const regex =  /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=|shorts\/)|youtu\.be\/)([^"&?\/\s]{11})/;
  const match = url.match(regex);
  return match && match[1];
};

const getPriceAfterDiscount = ({mainPrice, discount}) => {

    if (isNaN(mainPrice) || isNaN(discount) || mainPrice <= 0 || discount <= 0 || discount > 100) {
      return NaN;
    } else {
      return parseFloat((mainPrice - (mainPrice * (discount / 100))).toFixed(2));
    }
}

const extractInstagramUsername = (url) => {
  if(!url){
    return;
  }
  const regex = /(?:https?:\/\/)?(?:www\.)?instagram\.com\/([a-zA-Z0-9._]+)/;
  const match = url.match(regex);
  return match ? match[1] : null;
}
function extractTwitterUsername(url) {
  if(!url){
    return;
  }
  const regex = /(?:https?:\/\/)?(?:www\.)?twitter\.com\/([a-zA-Z0-9_]+)/;
  const match = url.match(regex);
  return match ? match[1] : null;
}

function decodeString(str) {
  if(!str){
    return "";
  }
  return str
    .replace(/_--_20/g, ' ')
    .replace(/_--_21/g, '!')
    .replace(/_--_22/g, '"')
    .replace(/_--_23/g, '#')
    .replace(/_--_24/g, '$')
    .replace(/_--_25/g, '%')
    .replace(/_--_26/g, '&')
    .replace(/_--_27/g, "'")
    .replace(/_--_28/g, '(')
    .replace(/_--_29/g, ')')
    .replace(/_--_2A/g, '*')
    .replace(/_--_2B/g, '+')
    .replace(/_--_2C/g, ',')
    .replace(/_--_3A/g, ':')
    .replace(/_--_3B/g, ';')
    .replace(/_--_3C/g, '<')
    .replace(/_--_3D/g, '=')
    .replace(/_--_3E/g, '>')
    .replace(/_--_40/g, '@')
    .replace(/_--_5B/g, '[')
    .replace(/_--_5C/g, '\\')
    .replace(/_--_5D/g, ']')
    .replace(/_--_5E/g, '^')
    .replace(/_--_60/g, '`')
    .replace(/_--_7B/g, '{')
    .replace(/_--_7C/g, '|')
    .replace(/_--_7D/g, '}')
    .replace(/_--_7E/g, '~');
}
function onImageError (e, defaultImg) {
  const fallbackImg =  defaultImg || placeholderImg;
  const imgTarget = e.target;
  if (imgTarget.src !== fallbackImg) {
    imgTarget.src = fallbackImg;
    imgTarget.setAttribute('data-placeholder-set', 'true');
    imgTarget.onerror = null;
  }

  if (imgTarget.getAttribute('data-placeholder-set') === 'true') {
    return false;
  }
}

function splitFullName(fullName) {
  const [first_name, ...last_name] = fullName?.split(' ');
  return { first_name, last_name: last_name?.join(' ') };
}

function checkPaginationEnd(res){
  const itemsLength = res?.data?.length;
  return itemsLength == 0 || itemsLength < res?.per_page;           
}
export {
  extractYouTubeId,
  trimText,
  useLocalStorage,
  lowerString,
  arabizeNumbers,
  toArabicNumber,
  upperString,
  isString,
  isTokenValid,
  generateRandomId,
  customValidators,
  roundWithHalf,
  youtubeParser,
  removeDuplicatedObjectsFromAnArray,
  getCurrentLocation,
  debounceFunc,
  parseQueryString,
  generateUniqueID,
  generateWhatsappLink,
  generateTelegramLink,
  stripAwaySpecialCharacters,
  isEmpty,
  extractInstagramUsername,
  extractTwitterUsername,
  cacheControl,
  constructQueryString,
  capFirstLetter,
  groupAttributesByParent,
  getPriceAfterDiscount,
  decodeString,
  onImageError,
  buildStoreLink,
  buildProductLink,
  splitFullName,
  updateParamOptionsInLocalStorage,
  useTempValue,
  checkPaginationEnd
}